<template>
  <div class="col-12 row q-col-gutter-x-sm items-center">
    <model-form-select
      :field="membershipTypesField"
      class="col-8"
      :label="`${(conditional.conditionsRequirements[excludeMembershipTypesField] ? 'Exclude' : 'Include')} Membership Types`"
      :options="membershipTypes.data"
      option-label="name"
      option-value="id"
      map-options
      emit-value
      multiple
      use-chips
      clearable
      :rules="[
        val => !!val || 'Field is required',
        val => val.length > 0 || 'Must select at least one membership type'
      ]"
    />
    <model-form-toggle
      :field="`conditionsRequirements.${excludeMembershipTypesField}`"
      class="col-4 q-mb-md"
      label="Exclude"
      value-type="Boolean"
    />
  </div>
</template>

<script>
import { CONDITIONS_REQUIREMENTS } from 'src/models/booking-fee-type/BookingFeeType'

export default {
  name: 'MembershipTypesConditionForm',
  configuration: ['membershipTypes'],
  props: {
    conditional: {
      type: Object,
      required: true
    },
    membershipTypesField: {
      type: String,
      default: CONDITIONS_REQUIREMENTS.MEMBERSHIP_TYPES
    },
    excludeMembershipTypesField: {
      type: String,
      default: CONDITIONS_REQUIREMENTS.EXCLUDE_MEMBERSHIP_TYPES
    }
  }
}

</script>
